export default "__VITE_ASSET__CJMAZKf2__"